(() => {
  'use strict';
  if (window.NiralaStickyCart) {
    window.NiralaStickyCart.init();
    return;
  }

  const mobile = window.matchMedia('(max-width: 800px)');
  let bar = null;
  let latestCart = null;
  let resizeObserver = null;
  let mutationObserver = null;
  let frame = 0;
  let started = false;

  function formatMoney(amount, currency, locale) {
    if (typeof window.Nirala?.formatMoney === 'function') return window.Nirala.formatMoney(amount, currency);
    try {
      return new Intl.NumberFormat(locale || undefined, { style: 'currency', currency }).format(amount / 100);
    } catch (_) {
      return `${(amount / 100).toFixed(2)}${currency ? ` ${currency}` : ''}`;
    }
  }

  function renderCart(cart) {
    if (!bar || !cart) return;
    const count = Number(cart.item_count);
    const total = Number(cart.total_price);
    if (!Number.isFinite(count) || count < 0 || !Number.isFinite(total) || total < 0) return;
    bar.dataset.itemCount = String(Math.floor(count));
    bar.dataset.totalPrice = String(total);
    const currency = typeof cart.currency === 'string' ? cart.currency : cart.currency?.iso_code;
    if (currency) bar.dataset.currency = currency;
    const countNode = bar.querySelector('[data-cart-count]');
    const totalNode = bar.querySelector('[data-sticky-cart-total]');
    if (countNode && countNode.textContent !== String(Math.floor(count))) countNode.textContent = String(Math.floor(count));
    if (totalNode) {
      const text = formatMoney(total, bar.dataset.currency || window.Nirala?.config?.currency, bar.dataset.locale || window.Nirala?.config?.locale);
      if (totalNode.textContent !== text) totalNode.textContent = text;
    }
  }

  function measurePadding(visible) {
    document.body.classList.toggle('np-has-sticky-cart', visible);
    if (visible) {
      const inset = Number.parseFloat(window.getComputedStyle(bar).bottom) || 0;
      const height = Math.ceil(bar.getBoundingClientRect().height + inset + 12);
      if (height > 0) document.documentElement.style.setProperty('--np-sticky-cart-height', `${height}px`);
    } else {
      document.documentElement.style.removeProperty('--np-sticky-cart-height');
    }
  }

  function sync() {
    frame = 0;
    const current = document.querySelector('[data-sticky-cart]');
    if (current !== bar) {
      resizeObserver?.disconnect();
      bar = current;
      if (bar && typeof ResizeObserver === 'function') {
        resizeObserver = new ResizeObserver(scheduleSync);
        resizeObserver.observe(bar);
      }
      if (bar && latestCart) renderCart(latestCart);
    }
    if (!bar) {
      measurePadding(false);
      return;
    }
    const visible = Number(bar.dataset.itemCount) > 0
      && (mobile.matches || bar.dataset.stickyCartDesktop === 'true')
      && !document.body.classList.contains('np-page--cart')
      && !document.querySelector('dialog[open]');
    bar.hidden = !visible;
    measurePadding(visible);
  }

  function scheduleSync() {
    if (!frame) frame = window.requestAnimationFrame(sync);
  }

  function update(cart) {
    if (!cart || !Number.isFinite(Number(cart.item_count)) || Number(cart.item_count) < 0 || !Number.isFinite(Number(cart.total_price)) || Number(cart.total_price) < 0) return;
    latestCart = cart;
    if (bar) renderCart(cart);
    sync();
  }

  function init() {
    if (!document.body) return;
    if (!started) {
      started = true;
      document.addEventListener('nirala:cart-updated', event => update(event.detail));
      document.addEventListener('shopify:section:load', scheduleSync);
      document.addEventListener('shopify:section:unload', scheduleSync);
      document.addEventListener('visibilitychange', scheduleSync);
      document.addEventListener('close', scheduleSync, true);
      document.addEventListener('cancel', scheduleSync, true);
      window.addEventListener('resize', scheduleSync, { passive: true });
      window.addEventListener('pageshow', scheduleSync);
      if (mobile.addEventListener) mobile.addEventListener('change', scheduleSync);
      else if (mobile.addListener) mobile.addListener(scheduleSync);
      if (typeof MutationObserver === 'function') {
        mutationObserver = new MutationObserver(scheduleSync);
        mutationObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
      }
    }
    sync();
  }

  window.NiralaStickyCart = { init, update };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
